import {zodResolver} from '@hookform/resolvers/zod';
import type {Resolver} from 'react-hook-form';
import {z} from 'zod';
import type {InstanceFormValues} from './sections/SectionProps';

export const instanceFormSchema = z
  .object({
    name: z.string().trim().min(1, 'Instance name is required'),
  })
  .catchall(z.any());

export const instanceFormResolver = zodResolver(
  instanceFormSchema
) as unknown as Resolver<InstanceFormValues>;
